import React from 'react';
import { Navigate } from 'react-router-dom';
import GlobalStore from '../stores/global-store';

function withSession(WrappedComponent) {
  const Wrapped = (props) => {
    const { session } = GlobalStore.useContainer();

    if (!session) {
      return <Navigate to="/login" />;
    }

    return <WrappedComponent {...props} />;
  };

  return Wrapped;
}

export default withSession;
